module.exports = __webpack_public_path__ + "static/one-image-lab-49915f13ec2c1de99e62174d73816bc5.webp";